import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Button, Typography } from "@aviary";
import { Container } from "@aviary/layouts";
import { SvgFullscriptIcon } from "@shared/assets/logo";
import { l } from "@shared/locales/i18n";
import type { To } from "@shared/react-router-dom";

import * as styles from "./Fallback.styles";

interface Props {
  to?: To;
  errorComponent?: ReactNode;
}

const Fallback: FC<Props> = ({ errorComponent, to }) => {
  const { t } = useTranslation();
  if (errorComponent) return <>{errorComponent}</>;

  const renderBackToHome = () => {
    if (!to) return null;

    return (
      <Button to={to} isColor="primary">
        {t(l.errorBoundary.BackToHome)}
      </Button>
    );
  };

  return (
    <Container css={styles.errorBoundary}>
      <div css={styles.content}>
        <Typography css={styles.title} type="h1">
          {t(l.errorBoundary.Oops)}
        </Typography>
        <div css={styles.subTitleContainer}>
          <SvgFullscriptIcon css={styles.logo} />
          <Typography css={styles.subTitle} type="h5">
            {t(l.errorBoundary.ApplicationErrorText)}
          </Typography>
        </div>
        <p css={styles.text}>{t(l.errorBoundary.ApplicationErrorMessage)}</p>
        {renderBackToHome()}
      </div>
    </Container>
  );
};

export { Fallback };
